export const ifExistCall = (func, ...args) => {
  if (func) {
    func(...args)
  }
}
